<template>
  <div>
    <header class="navbar navbar-expand navbar-light bg-white container header-social">
      <div class="divisor-vertical-gris">
        <a class="navbar-brand" target="_blank" href="https://www.uapa.edu.do/">
          <img src="../../../static/img/logo_uapa_azul.png" class="logo-uapa-social" alt="">
        </a>
      </div>
      <div class="collapse navbar-collapse col-md-4 divisor-vertical-naranja" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <span class="nav-link social-label" href="#">S&iacute;guenos: </span>
          </li>
          <li class="nav-item">
            <a class="nav-link" target="_blank" href="https://www.youtube.com/channel/UCuHpTq7qj7OaErE37P8fQ1Q">
              <i class="icon-social-youtube icons font-sm icon d-block mt-4 text-blue-uapa"></i></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" target="_blank" href="https://twitter.com/#!/uniuapa">
              <i class="icon-social-twitter icons font-sm icon d-block mt-4 text-blue-uapa"></i></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" target="_blank" href="https://instagram.com/uniuapa">
              <i class="icon-social-instagram icons font-sm icon d-block mt-4 text-blue-uapa"></i></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" target="_blank" href="https://www.facebook.com/uniuapa">
              <i class="icon-social-facebook icons font-sm icon d-block mt-4 text-blue-uapa"></i></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" target="_blank" href="https://www.uapa.edu.do/radio/">
              <i class="icon-volume-2 icons font-sm icon d-block mt-4 text-blue-uapa"></i></a>
          </li>

        </ul>
      </div>
      <li class="nav-item mr-3 d-sm-none d-md-block d-none d-sm-block">
        <span class="social-label-azul">LA UNIVERSIDAD VIRTUAL DE LA REPÚBLICA DOMINICANA</span>
      </li>
    </header>
    <!--<header class="navbar navbar-expand-lg navbar-dark">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
     &lt;!&ndash; <div><a class="navbar-brand mr-0 mr-md-5" href="/" aria-label="Bootstrap">
        <img src="../../../static/img/logo.png" class="logo" alt="Responsive image"/>
      </a></div>&ndash;&gt;
      &lt;!&ndash; <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
               aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
         <span class="navbar-toggler-icon"></span>
       </button>&ndash;&gt;
      <div class="collapse navbar-collapse menu-principal" id="navbarTogglerDemo03">

        <ul class="navbar-nav">
          <li class="nav-item">
            &lt;!&ndash;<a class="nav-link active" href="/">Home</a>&ndash;&gt;
            <router-link to="/index" class="nav-link">Inicio</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/publicaciones" class="nav-link">Producci&oacute;n Cient&iacute;fica</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/banco_problemas" class="nav-link">Banco de Problemas</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/proyectos" class="nav-link">Proyectos</router-link>
          </li>


          <b-nav-item-dropdown id="nav7_ddown" text="Productos de Informaci&oacute;n"
                               extra-toggle-classes="nav-link-custom" right>
            <a class="dropdown-item" href="/">Informes de Producci&oacute;n Cient&iacute;fica </a>
            <router-link to="/directorio" class="dropdown-item">Directorio de Revistas</router-link>
          </b-nav-item-dropdown>

          <li class="nav-item">
            <router-link to="/herramientas" class="nav-link">Herramientas para Investigadores</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/sobrenosotros" class="nav-link">Sobre Nosotros</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/enlacesinteres" class="nav-link">Enlaces de Interés</router-link>
          </li>
          &lt;!&ndash;<li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle mr-md-2" href="#" id="versions" data-toggle="dropdown"
               aria-haspopup="true"
               aria-expanded="false">
              Products
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="versions">
              <a class="dropdown-item" href="/">CoreUI</a>
              <a class="dropdown-item" href="/angular">CoreUI for Angular</a>

              <a class="dropdown-item" href="/react">CoreUI for React.js</a>
              <a class="dropdown-item" href="/vue">CoreUI for Vue.js</a>
              <hr>
              <a class="dropdown-item" href="/pro/">CoreUI <strong>Pro</strong></a>
              <a class="dropdown-item" href="/pro/angular">CoreUI <strong>Pro</strong> for Angular</a>

              <a class="dropdown-item" href="/pro/react">CoreUI <strong>Pro</strong> for React.js</a>
              <a class="dropdown-item" href="/pro/vue">CoreUI <strong>Pro</strong> for Vue.js</a>
              <hr>
              <a class="dropdown-item" href="/icons/">CoreUI Icons</a>
            </div>
          </li>&ndash;&gt;
        </ul>
        &lt;!&ndash;<ul class="navbar-nav ml-md-auto">
          <li class="nav-item mr-3">
            <a class="btn btn-warning" href="/pro/" onclick="ga('send', 'event', 'Go Pro', 'Click', 'Navbar');">Go Pro</a>
          </li>
          <li class="nav-item">
            <a class="btn btn-outline-warning" href="http://holeczek.pl"
               onclick="ga('send', 'event', 'About me', 'Click');">About me</a>
          </li>
        </ul>&ndash;&gt;
      </div>

    </header>-->

    <b-navbar toggleable="lg" type="dark" class="header align-content-center">
      <!--<b-navbar-brand href="#">INNOTEC-UAPA</b-navbar-brand>-->
      <b-navbar-brand href="/" class="px-5">
        <img src="../../../static/img/logo.png" class="logo" alt="BV"/>
      </b-navbar-brand>

      <b-navbar-toggle target="nav_collapse"/>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <ul class="navbar-nav">
            <li class="nav-item">
              <!--<a class="nav-link active" href="/">Home</a>-->
              <router-link to="/index" class="nav-link">Inicio</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/sobrenosotros" class="nav-link">Sobre Nosotros</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/publicaciones" class="nav-link">Producci&oacute;n Cient&iacute;fica</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/banco_problemas" class="nav-link">Banco de Problemas</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/proyectos" class="nav-link">Proyectos</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/herramientas" class="nav-link">Herramientas para Investigadores</router-link>
            </li>
            <b-nav-item-dropdown id="nav7_ddown" text="Productos de Informaci&oacute;n"
                                 extra-toggle-classes="nav-link-custom" right>
              <!--<a class="dropdown-item" href="/">Informes de Producci&oacute;n Cient&iacute;fica </a>-->
              <router-link to="/directorio" class="dropdown-item">Directorio de Revistas</router-link>
            </b-nav-item-dropdown>

            <li class="nav-item">
              <router-link to="/enlacesinteres" class="nav-link">Enlaces de Interés</router-link>
            </li>
          </ul>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
      </b-collapse>
    </b-navbar>

    <main class="masthead text-white <!--header-image img-fluid--> header-second" id="content" role="main"
          style="overflow:hidden">
      <div class="container">
        <div class="row mt-2">
          <!--<h1 class="text-white" > {{($route.name === 'Index')?"":$route.name}}</h1>
          <h1 class="text-white" > {{$route.description}}</h1>-->
        </div>
        <div class="row text-image-header">
          <b-col md="8" class="left">
            <h1 class="text-white"> {{($route.name === 'Index')?"":$route.name}}</h1>
            <h1 class="text-white"> {{$route.description}}</h1>
            <!--<img src="../../../static/img/logo_blanco.png" class="logo_central" alt="Responsive image"/>-->
            <!--<h1 class="mb-3 text-sm-nowrap">CoreUI</h1>
            <h2 class="mb-3 text-sm-nowrap">Free Bootstrap Admin Template</h2>
            <p class="lead">
              The only Bootstrap Admin Template you need to <strong>create amazing user interfaces</strong>.
            </p>-->
            <!--<p class="-paragraph mb-4 text-justify">
              {{title}}
            </p>-->
            <p class="-paragraph mb-4 text-justify text-white" v-html="changeHeader"></p>
            <b-button hidden href="#" class="small boton-header pull-right" size="sm">Leer más &nbsp; <i
              class="fa fa-caret-right boton-header"></i></b-button>
          </b-col>
          <b-col md="3"><img :src="imagen" alt="" class="img-fluid" style="max-width: 200%!important" fluid>
          </b-col>

        </div>
      </div>
      <!--<b-col v-if="this.directorio"><img :src="imagen" alt="" class="img-fluid" style="" fluid></b-col>-->
    </main>
  </div>
</template>
<script>
  import HeaderDropdown from './HeaderDropdown.vue'
  import BNavbar from 'bootstrap-vue/es/components/navbar/navbar'
  import {mapGetters, mapState} from 'vuex'
  import {description} from "./dataHeader";
  import VueI18n from 'vue-i18n'

  export default {
    name: 'c-header',
    components: {
      HeaderDropdown,
      VueI18n,
      BNavbar
    },
    props: {
      //title: String
    },
    methods: {
      sidebarToggle(e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-hidden')
      },
      sidebarMinimize(e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-minimized')
      },
      mobileSidebarToggle(e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      },
      asideToggle(e) {
        e.preventDefault()
        document.body.classList.toggle('aside-menu-hidden')
      },

    },
    computed: {
      ...mapGetters(['title', 'imagen']),
      ...mapState({
        jwt: state => state.login.jwt
      }),
      directorio() {
        return this.title == 'directorio'
      },
      changeHeader() {
        var temp
        if (this.$route.name === 'Index')
          temp = description.get('index')
        else if (this.$route.name === 'Banco de Problemas')
          temp = description.get('bp')
        else if (this.$route.name === 'Sobre Nosotros')
          temp = description.get('nosotros')
        else if (this.$route.name === 'Herramientas para Investigadores')
          temp = description.get('herramientas')
        else if (this.$route.name === "Producción Científica")
          temp = description.get('pc')
        else if (this.$route.name === "Proyectos")
          temp = description.get('proyectos')
        else if (this.$route.name === "Directorio de Revistas")
          temp = description.get('dr')
        else if (this.$route.name === "Enlaces de Interes")
          temp = description.get('ei')
        return temp
        /*switch ($route.name) {
          case 'Index':
            temp = description.get('index')
            break;
          case 'Banco de Problemas':
            temp = description.get('bp')
            break;
          case 'publicaciones':
            break;
          case 'Herramientas':
            temp = description.get('herramientas')
            break;
          case 'Nosotros':
            temp = description.get('nosotros')
            break;
          case 'Directorio de Revistas':
            temp = 'directorio'
            break;
          case 'EnlacesInteres':
            break;

        }*/
      }
    }
  }
</script>

<style>
  header.app-header.navbar,
  header.app-header.navbar .navbar-brand {
    background-color: #F99F47;
    border-bottom-color: #101734;
    border-bottom-width: medium;
    color: white;
  }

  header, .header {
    background: #182458e6;
    color: white !important;
  }

  .header-second {
    background: rgb(25, 36, 89);
    background: linear-gradient(180deg, rgba(25, 36, 89, 1) 12%, rgba(8, 23, 79, 1) 71%, rgba(24, 36, 88, 1) 72%);
    color: white !important;
  }

  .text-image-header {
    margin-top: 25px;
  }
  .text-image-header > div >h1{
    padding-top: 10px;
  }

  /*.header-second > .container > .row{
    padding-bottom: 20px;
  }*/
  .navbar-dark .navbar-nav .nav-link {
    color: white !important;
    font-weight: bolder;
  }

  .navbar.center .navbar-collapse .nav {
    float: none;
    display: inline-block;
    vertical-align: middle;
  }

  .mt-4, .my-4 {
    margin-top: 0.5rem !important;
  }

  .logo-uapa-social {
    height: auto;
    width: 70px;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }

  .divisor-vertical-gris {
    border-right: 2px solid #6e6f7c;
    border-right-width: medium;
    /*margin-left: -3px;*/
  }

  .divisor-vertical-naranja {
    border-right: 2px solid #F99F47;
    border-right-width: medium;
    margin-right: 10px;
    /*margin-left: -3px;*/
  }

  .social-label {
    color: #F99F47 !important;
    font-weight: bold;
  }

  .social-label-azul {
    color: #172356 !important;
    font-weight: bold;
  }

  .text-blue-uapa {
    color: #172356;
    font-size: 13px;
  }

  .text-blue-uapa:hover {
    color: #F99F47;
  }

  .header-social {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue